import React, {useState} from 'react'
import Games from './Games'
import {GameQuestions} from './GameQuestions'

// Wrapper: danh sách game (Games) <-> quản lý câu hỏi của 1 game (GameQuestions), toggle bằng
// state cục bộ thay vì thêm 1 route con - khớp quy mô nhỏ của phần biên soạn Kristo Games.
const GamesArea = (props) => {
    const [selectedGame, setSelectedGame] = useState(null)

    if (selectedGame) {
        return <GameQuestions game={selectedGame} onBack={() => setSelectedGame(null)}/>
    }

    return <Games {...props} onNavigateQuestions={setSelectedGame}/>
}

export default GamesArea
